import { getData_Vehicle } from '@/components/report/service';
import { crudRequest } from '@/services/api';
import { calculateDiff, groupBys, groupBysAggreObject } from '@/utils/columnSearch';
import { computeWeightNotAbs } from '@/utils/query';
import moment from 'moment';
import { DesSiteDetailQuery } from '../Tables/PlanDepartureTable/Sql';

const params = {}
export default {
  namespace: 'stockweightviewmodalsTest2',
  state: {
    modalsVisible: false,
    modalsTitle: '',
    modalsNextSiteCode: '',
    scanSite: '',

    // 产品类型饼图
    productList: [],
    // 是否优势产品
    superiorityProductList: [],
    // 发往目的货量
    desSiteToNextSiteList: [],

    loadExportDataList: [],
    unloadExportDataList: [],
    unloadProductData: [],
    loadProductData: [],
    diffStockData: []
  },

  effects: {
    // 重置
    *setReset(_, { put }) {
      yield put({ type: 'update', payload: { modalsVisible: false, } });
    },
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload },
      });
      crudRequest('/api/route/centerweightview/stock_detail')
      yield put({ type: 'getDataSource' });
    },
    // 产品时效类型
    *getDepartureProducts({ payload }, { put }) {
      let { stockData } = payload
      let groupData = groupBys(stockData, 'productType')
      let productList = groupBysAggreObject(groupData, ['calcWeight'])
      productList = productList.map(item => {
        if (item.calcWeight > 0.01)
          return ({ name: item.productType, value: computeWeightNotAbs(item.calcWeight) })
      })
      yield put({ type: 'update', payload: { productList } })
    },
    // 库存(非/优)势产品
    *getDeparturesuPeriorityLists({ payload }, { put, call, select }) {
      const { stockData } = payload
      const superiorityProduct = { '是': '优势业务', '否': '非优势业务' }
      let groupData = groupBys(stockData, 'superiorityProduct')
      let superiorityProductList = groupBysAggreObject(groupData, ['ticket'])
      superiorityProductList = superiorityProductList.map(item => {
        // if (item.ticket > 0)
        return ({
          name: superiorityProduct[item.superiorityProduct],
          value: item.ticket
        })
      })
      yield put({ type: 'update', payload: { superiorityProductList } })
    },
    /** 明细 */
    *getDetailDataLists({ payload }, { put }) {
      let { stockData } = payload
      let groupData = groupBys(stockData, 'destinationCenter')
      let desSiteToNextSiteList = groupBysAggreObject(
        groupData,
        ['calcWeight', 'goodsWeight', 'goodsVolume', 'ticket', 'piece'],
      )
      let acount = 0  // 获取重量总和
      desSiteToNextSiteList.forEach(m => { acount += m.calcWeight })
      desSiteToNextSiteList = desSiteToNextSiteList.sort((a, b) => {
        return (b.calcWeight - a.calcWeight)
      }).map(item => ({
        ...item, proportion: (item.calcWeight / Math.abs(acount) * 100).toFixed(1)
      }))
      yield put({ type: 'update', payload: { desSiteToNextSiteList } })
    },
    *getDataSource(_, { put, call, select }) {
      let { startDate, endDate, datadbName,
        currentStartTime, currentEndTime } = yield select(({ centerWeightView2Test2 }) => {
          return {
            ...centerWeightView2Test2,
            startDate: moment(centerWeightView2Test2.dateRange[0]).format(centerWeightView2Test2.defualtDateFormat),
            endDate: moment(centerWeightView2Test2.dateRange[1]).format(centerWeightView2Test2.defualtDateFormat),
            currentStartTime: moment(centerWeightView2Test2.crrentDateRange[0]).format('YYYY-MM-DD HH:mm:ss'),
            currentEndTime: moment(centerWeightView2Test2.crrentDateRange[1]).format('YYYY-MM-DD HH:mm:ss'),
          }
        });
      const { modalsNextSiteCode: nextSiteCode, scanSiteCode } =
        yield select(({ stockweightviewmodalsTest2 }) => stockweightviewmodalsTest2)
      const params = {
        scanSiteCode, nextSiteCode, startDate, endDate,
        currentStartTime: currentStartTime,
        currentEndTime: currentEndTime,
      }
      const { unload } = DesSiteDetailQuery(params)
      let unloadProductData = yield call(getData_Vehicle, unload, datadbName)

      // unloadProductData.map(m => {
      //   if (!m.piece) {
      //     console.log('m.piece', m)
      //   }
      // })
      // 卸车件数至少大于0的
      const unloadWyaZero = []
      unloadProductData = unloadProductData.filter(m => {
        if (!m.piece)
          unloadWyaZero.push(m)
        return !!m.piece
      })
      // 根据卸车单号查装车数据，需要卸车单号存在
      const waybillNos = unloadProductData.map(m => m.waybillNo)
      const { load } = DesSiteDetailQuery({ ...params, waybillNos })
      let loadProductData = yield call(getData_Vehicle, load, datadbName)

      // 卸车件数至少大于0的
      const loadWyaZero = []
      loadProductData = loadProductData.filter(m => {
        if (!m.piece)
          loadWyaZero.push(m)
        return !!m.piece
      })

      //#region 差异装车
      // load.inFilters = []
      // let loadProductData_not_way = yield call(getData_Vehicle, load, datadbName)

      // const diffStockData = loadProductData_not_way.filter(diffLoad => (
      //   !loadProductData.find(loadItem => (
      //     diffLoad.waybillNo === loadItem.waybillNo &&
      //     diffLoad.destinationCenter === loadItem.destinationCenter &&
      //     diffLoad.productType === loadItem.productType &&
      //     diffLoad.planNextSite === loadItem.planNextSite
      //   ))
      // )).map(m => {
      //   m.nextSite = m.planNextSite
      //   const findWyaZero = unloadWyaZero.find(wyaZeor => {
      //     return wyaZeor.waybillNo === m.waybillNo
      //   })
      //   if (findWyaZero) {
      //     m.remark = '卸车为件数0'
      //   }

      //   return m
      // })
      //#endregion

      const ticketWay = (item, tickets) => {
        if (item.ticket === 0 && item.piece !== 0) {
          item.ticket = tickets
        }
        return item
      }

      const stockData = calculateDiff(
        unloadProductData,
        loadProductData,
        ['calcWeight', 'goodsWeight', 'goodsVolume', 'ticket', 'piece'],
        (unItem, loadItem) => {
          return (
            unItem.waybillNo === loadItem.waybillNo &&
            unItem.destinationCenter === loadItem.destinationCenter &&
            unItem.productType === loadItem.productType &&
            unItem.nextSite === loadItem.planNextSite
          )
        }
      ).filter(m => m.calcWeight !== 0 || m.goodsWeight !== 0
        || m.goodsVolume !== 0 || m.ticket !== 0 || m.piece !== 0);
      unloadProductData = unloadProductData.map((item) => ticketWay(item, 1))
      loadProductData = loadProductData.map((item) => ticketWay(item, -1))
      const payload = {
        unloadProductData: [...unloadProductData],
        loadProductData: [...loadProductData],
        stockData,
        // diffStockData
      }
      yield put({ type: 'update', payload })
      yield put({ type: 'getDetailDataLists', payload })
      yield put({ type: 'getDepartureProducts', payload });
      yield put({ type: 'getDeparturesuPeriorityLists', payload });
    },
  },

  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}
